import React, { useEffect, useState } from "react";
import "../../Styles/EmployeePayroll.css";
import { useSelector } from "react-redux";
import Header from "../../Core/Header";
import { Section } from "../../Core/Section";
import { doctorCommissionId, doctorList, doctorPayRollPaymentAPI, employeeList, employeePayRoleApi, PayRollAPI } from "../../Services/Operations/ProductAPI";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";

const DoctorPayRoll = () => {
  const token = useSelector((state) => state.user.token);
  const [doctors, setDoctors] = useState([]);
  const [commissions, setCommissions] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  const [doctorCommission, setDoctorCommission] = useState(null);
  const [paymentData, setPaymentData] = useState({
    amountToPay: 0,
    dueAmount: 0,
    paymentNote: ""
  });
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const [currentCommisions,setCurrentCommisions]=useState([])

  const navigate = useNavigate();
  const location = useLocation();
  const { EmployeeSelectId } = location.state || {};

  useEffect(() => {
    const fetchDoctorList = async () => {
      try {
        const response = await doctorList(token);
        console.log("doctor response : ", response);
        setDoctors(response);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchDoctorList();
  }, []);

  useEffect(() => {
    const fetchCommissionList = async () => {
      try {
        const response = await PayRollAPI(token);
        console.log("commission response : ", response);
        setCommissions(response.data);
      } catch (error) {
        console.error("Error fetching commissions:", error);
      }
    };
    fetchCommissionList();
  }, []);

  const handleSelectDoctor = async(doctor) => {
    setSelectedDoctor(doctor);
    // Find the commission for the selected doctor
    const doctorCommission = commissions.find(commission => commission.doctorId === doctor.id);
    setDoctorCommission(doctorCommission);
    setShowPaymentForm(false);
    setPaymentData({
      amountToPay: 0,
      dueAmount: doctorCommission ? doctorCommission.totalCommission : 0,
      paymentNote: ""
    });


    try {
      let data={
        id:doctor.id,
        token
      }
      const response=await doctorCommissionId(data)
      console.log(response);
      setCurrentCommisions(response.data)
      
    } catch (error) {
      console.log();
      
    }
  };

  const handlePaymentClick = () => {
    setShowPaymentForm(true);
  };

  const handlePaymentChange = (e) => {
    const { name, value } = e.target;
    
    if (name === "amountToPay") {
      const amount = parseFloat(value) || 0;
      const newDueAmount = (doctorCommission ? doctorCommission.totalCommission : 0) - amount;
      
      setPaymentData(prev => ({
        ...prev,
        amountToPay: amount,
        dueAmount: newDueAmount >= 0 ? newDueAmount : 0,
        [name]: name === "amountToPay" ? amount : value
      }));
    } else {
      setPaymentData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handlePaymentSubmit = async (e) => {
    e.preventDefault();
    
    if (!selectedDoctor) {
      toast.error("Please select a doctor");
      return;
    }

    if (paymentData.amountToPay <= 0) {
      toast.error("Payment amount must be greater than 0");
      return;
    }

    if (paymentData.amountToPay > (doctorCommission?.totalCommission || 0)) {
      toast.error("Payment amount cannot exceed total commission");
      return;
    }

    try {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, '0');
      const month = String(today.getMonth() + 1).padStart(2, '0'); 
      const year = today.getFullYear();
      const formattedDate = `${day}-${month}-${year}`;
      
      const response = await doctorPayRollPaymentAPI({
        doctorId: selectedDoctor.id,
        paidAmount: paymentData.amountToPay,
        paymentNote: paymentData.paymentNote,
        paymentDate: formattedDate,
      }, token);

      console.log("response : ", response);

      if (response.status === 200) {
        toast.success(`Payment of ₹${paymentData.amountToPay} processed successfully!`);

        const updatedCommission = {
          ...doctorCommission,
          totalCommission: paymentData.dueAmount,
          updatedAt: new Date().toISOString()
        };
        setDoctorCommission(updatedCommission);
        
        setCommissions(commissions.map(commission => 
          commission.doctorId === selectedDoctor.id ? updatedCommission : commission
        ));
        
        setPaymentData({
          amountToPay: 0,
          dueAmount: paymentData.dueAmount,
          paymentNote: ""
        });
        
        setShowPaymentForm(false);
      } else {
        toast.error(response.data?.message || "Payment processing failed");
      }
    } catch (error) {
      console.error("Payment processing error:", error);
      toast.error(error.response?.data?.message || "Payment processing failed");
    }
  };

  return (
    <div id="main_content">
      <Header />
      <div className="page payroll-wrapper">
        <Section />
        <div className="payroll-container">
          <div className="employee-sidebar">
            <h3>Doctors</h3>
            {doctors.map((doctor) => (
              <div
                key={doctor.id}
                className={`employee-card ${selectedDoctor?.id === doctor.id ? "active" : ""}`}
                onClick={() => handleSelectDoctor(doctor)}
              >
                {doctor.firstName} {doctor.lastName}
              </div>
            ))}
          </div>

          <div className="form-section">
            {selectedDoctor ? (
              <div className="doctor-details">
                <h2>Commission Details for {selectedDoctor.firstName} {selectedDoctor.lastName}</h2>
                <div style={{height:"fit-content",maxHeight:"70vh",overflowY:"auto",padding:"20px",borderRadius:"10px",border:"0.3px solid #969595",margin:"10px",display:"flex",flexDirection:"column",gap:"10px"}}>
              {currentCommisions.length>0?   currentCommisions.map((item,ind)=>(
                <div className="info-box">
                      <p><strong>Total Commission:</strong> ₹{item.commissionAmount}</p>
                      <p><strong>Last Updated:</strong> {new Date(item.createdAt).toLocaleDateString()}</p>
                      <hr/>
                      <p><strong>PatientDetails:</strong> {item.patientName}</p>
                      <p> {item.patientEmail}</p>
                      <p> {item.patientMobile}</p>
                    </div>
              )):
              <p>No Commission data</p>  }
              </div>
                
                {doctorCommission ? (
                  <>
                    <div className="info-box">
                      <p><strong>Total Commission:</strong> ₹{doctorCommission.totalCommission}</p>
                      <p><strong>Last Updated:</strong> {new Date(doctorCommission.updatedAt).toLocaleDateString()}</p>
                    </div>
                    
                    {!showPaymentForm ? (
                      <button 
                        onClick={handlePaymentClick}
                        className="submit-btn"
                        disabled={doctorCommission.totalCommission <= 0}
                      >
                        Make Payment
                      </button>
                    ) : (
                      <form className="payment-form" onSubmit={handlePaymentSubmit} style={{marginTop: "24px"}}>
                        <div className="form-group">
                          <label>Amount to Pay</label>
                          <input 
                            type="number" 
                            name="amountToPay" 
                            value={paymentData.amountToPay} 
                            onChange={handlePaymentChange} 
                            min="0"
                            max={doctorCommission.totalCommission}
                            step="0.01"
                          />
                        </div>
                        <div className="form-group">
                          <label>Due Amount After Payment</label>
                          <input 
                            type="number" 
                            name="dueAmount" 
                            value={paymentData.dueAmount} 
                            readOnly
                          />
                        </div>
                        <div className="form-group">
                          <label>Payment Note</label>
                          <textarea
                            name="paymentNote"
                            value={paymentData.paymentNote}
                            onChange={handlePaymentChange}
                            placeholder="Enter payment note (optional)"
                            rows="3"
                          />
                        </div>
                        <div className="payment-buttons">
                          <button 
                            type="button" 
                            className="cancel-btn"
                            onClick={() => setShowPaymentForm(false)}
                          >
                            Cancel
                          </button>
                          <button 
                            type="submit" 
                            className="submit-btn"
                            disabled={paymentData.amountToPay <= 0}
                          >
                            Confirm Payment
                          </button>
                        </div>
                      </form>
                    )}
                  </>
                ) : (
                  <div className="info-box">
                    <p>No commission data available for this doctor.</p>
                  </div>
                )}
              </div>
            ) : (
              <div className="form-placeholder">Select a doctor to view commission details</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DoctorPayRoll;